import { defineStore } from 'pinia';

const actions = {
	/* eslint-disable no-shadow */
	updateAnsweredCorrect(key, data) {
		this.rmq[key].answeredCorrect = data;
	},
	updatePctCorrect(key, data) {
		this.rmq[key].pctCorrect = data;
	},
	updateQuestAnswered(key, data) {
		this.rmq[key].questAnswered = data;
	},
	updateQuizComplete(key, data) {
		this.rmq[key].quizComplete = data;
	},
	updateResultText(key, data) {
		this.rmq[key].resultText = data;
	},
	updateSelectedData(key, data) {
		this.rmq[key].selectedData.push(data);
	},
	resetSelectedData(key) {
		this.rmq[key].selectedData = [];
	},
	addQuizState(key) {
		this.rmq[key] = {
			answeredCorrect: 0,
			pctCorrect: 20,
			questAnswered: 0,
			quizComplete: false,
			resultText: 0,
			selectedData: [],
		};
	},

	/* eslint-disable no-shadow */
};

const getters = {
	// eslint-disable-next-line no-shadow
	/*
	 * answeredCorrect: (state) => state.answeredCorrect,
	 * correctIndex: (state) => state.correctIndex,
	 * pctCorrect: (state) => state.pctCorrect,
	 * questAnswered: (state) => state.questAnswered,
	 * quizComplete: (state) => state.quizComplete,
	 * resultText: (state) => state.resultText,
	 * selectedData: (state) => state.selectedData,
	 */
};

// eslint-disable-next-line import/prefer-default-export
export const useQuizStore = defineStore({
	id: 'quiz',
	state: () => ({
		rmq: {},
	}),
	getters,
	actions,
});
